import React, { memo, useCallback, useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
// eslint-disable-next-line import/no-unresolved
import Select from "react-select";

import styles from "@styles/checkout/order.module.scss";
import { useGoodCause } from "@context/GoodCauseProvider";
import { useApp } from "@context/AppProvider";
import { api } from "@utils/api";
import Loading from "@components/Loading";
import { goodCauseShowRetailerWise } from "@utils/functions";
const Goodcause = ({
  callBackUpdateCharity,
  charity = {},
  isRandom = false,
  goodCause,
}) => {
  const {
    idb: { user, session },
  } = useApp();
  const { gc, updateGoodCause } = useGoodCause();
  const [data, setData] = useState({
    loader: true,
    charities: [],
    selectedCharity: isRandom ? {} : charity,
    showCharitiModal: user?.charity?._id ? false : true,
    stateChatities: [],
    addressMatch: false,
    randomCharity: isRandom,
  });
  const getCharities = useCallback(async () => {
    try {
      const charities = await api(
        {
          url: `/user/charities`,
          method: "POST",
        },
        session
      );
      if (charities.charity.length > 0) {
        setData((preState) => ({
          ...preState,
          charities: charities.charity,
          loader: false,
        }));
      }
    } catch (e) {
      // doe some thing
    }
  }, [session]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const updateSelectedCharity = useCallback(() => {
    let charitiesData = data.charities;
    const selectedCharity = gc._id
      ? charitiesData.find((item) => {
          return item._id === gc._id;
        })
      : null;

    setData((preState) => ({
      ...preState,
      selectedCharity: selectedCharity,
    }));
    callBackUpdateCharity(selectedCharity);
  }, [callBackUpdateCharity, data.charities, gc._id]);

  const getCharityImage = () => {
    return data.selectedCharity?.charityLogo || "/assets/svg/placeholder.svg";
  };

  const getCharityPageUrl = () => {
    const url = data.selectedCharity?.charityPageUrl;
    if (!url) return null;
    if (/^https?:\/\//i.test(url)) return url;
    return `/${url.replace(/^\/+/, "")}`;
  };

  const callbackCharityModal = useCallback(
    (selectedCharities) => {
      if (selectedCharities) {
        let charitiesData = data.charities ? data.charities : [];
        const selectedCharity = charitiesData.find((item) => {
          return item._id === selectedCharities.value;
        });

        setData((preState) => ({
          ...preState,
          showCharitiModal: false,
          selectedCharity: selectedCharity,
        }));

        updateGoodCause({
          _id: selectedCharity._id,
          name: selectedCharity.registeredCharityName,
        });
      } else {
        setData((preState) => ({
          ...preState,
          showCharitiModal: true,
        }));
      }
    },
    [data.charities, updateGoodCause]
  );

  const handleOnChange = () => {
    const randomCharity = !data.randomCharity;
    if (randomCharity) {
      let random = Math.floor(Math.random() * data.charities.length);
      callBackUpdateCharity(data.charities[random], true);
    } else {
      callBackUpdateCharity(null, false);
    }
    setData((preState) => ({
      ...preState,
      randomCharity,
    }));
  };

  useEffect(() => {
    if (session) getCharities();
  }, [getCharities, session]);

  useEffect(() => {
    if (data.charities && gc && gc._id) {
      updateSelectedCharity();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.charities, gc, updateSelectedCharity]);

  const charityOptions = data.charities?.length
    ? data.charities.map((option) => ({
        value: option._id,
        label: option.registeredCharityName,
      }))
    : [];

  const selectedCharity =
    charityOptions.find((i) => data.selectedCharity?._id === i.value) || null;

  return (
    <>
      <div className={styles.destinationHd}>
        <h2>Your Good Cause</h2>
      </div>
      {data.loader ? (
        <div className="pt-5 pb-5">
          <Loading.LineLoader />
        </div>
      ) : (
        <div className={styles.causeImg}>
          {data.selectedCharity &&
            !!Object.keys(data.selectedCharity).length && (
              <>
                {getCharityPageUrl() ? (
                  <Link href={getCharityPageUrl()} target="_blank">
                    <Image
                      width="337"
                      height="120"
                      src={getCharityImage()}
                      alt="cause"
                      style={{ objectFit: "contain" }}
                    />
                  </Link>
                ) : (
                  <Image
                    width="337"
                    height="120"
                    src={getCharityImage()}
                    alt="cause"
                    style={{ objectFit: "contain" }}
                  />
                )}
              </>
            )}
          {data.selectedCharity &&
            !!Object.keys(data.selectedCharity).length &&
            getCharityPageUrl() && (
              <Link href={getCharityPageUrl()} target="_blank">
                <p className={styles.moreInfo}>More Info</p>
              </Link>
            )}
          <div className={styles.causeText}>
            {data.selectedCharity &&
            Object.keys(data.selectedCharity).length ? (
              <p>
                {/* We&apos;ll make A donation of */}{" "}
                <b>${goodCause?.amount.toFixed(2) || 0}</b> will be donated to
                your Good Cause when you buy this.{" "}
                {/* <b>{data.selectedCharity.registeredAbnName}</b> on your behalf
								when you buy this. */}
              </p>
            ) : (
              <p className={styles.noCause}>
                {/* We&apos;ll make A donation of */}$
                {goodCause?.amount.toFixed(2) || 0} will be donated to your Good
                Cause when you buy this.
              </p>
            )}

            <span
              onClick={() => {
                setData((preState) => ({
                  ...preState,
                  showCharitiModal: true,
                }));
              }}
            >
              {data.selectedCharity &&
              Object.keys(data.selectedCharity).length &&
              !data.showCharitiModal
                ? `Change your Good Cause`
                : ""}
            </span>
          </div>
          {data.showCharitiModal && (
            <div className={styles.selectbox}>
              <Select
                className="basic-single selectGoodCause"
                classNamePrefix="select"
                placeholder="Select Good Cause"
                //isClearable={true}
                isSearchable={true}
                name="charity"
                options={charityOptions}
                value={selectedCharity}
                onChange={(e) => {
                  callbackCharityModal(e);
                }}
              />
            </div>
          )}

          {!data.selectedCharity ||
            (!Object.keys(data.selectedCharity).length && (
              <div className={styles.textOr}>OR</div>
            ))}
          {!data.selectedCharity ||
            (!Object.keys(data.selectedCharity).length && (
              <div className={styles.checkBox}>
                <div className="form-group d-flex align-items-center justify-content-between">
                  <label className="custom-check">
                    Pick a Good Cause for me instead.
                    <input
                      type="checkbox"
                      checked={data.randomCharity}
                      name="randomPick"
                      onChange={() => {
                        handleOnChange();
                      }}
                    />
                    <span className={`${styles.checkmark} checkmark`}></span>
                  </label>
                </div>
              </div>
            ))}
          <div className={styles.goodCausePage}>
            <p>
              Can’t find your favourite Good Cause listed? You can let us know
              who they are{" "}
              <span>
                <Link href="/give" target="_blank">
                  here
                </Link>
              </span>
              . We’ll get in touch with them to see if we can bring them on
              board for next time you shop with us.
            </p>
          </div>
          {goodCause?.retailerGcTotal &&
            goodCauseShowRetailerWise(goodCause.retailerGcTotal).map(
              (gcause, key) => (
                <div key={key} className={styles.retailerGoodCauseDetails}>
                  {" "}
                  <p>
                    <b>{gcause.map((mp) => mp.shop_name).join(", ")}</b> will
                    also donate{" "}
                    <b>
                      {gcause
                        .map((mp) => "$" + mp.retailerDonationAmount.toFixed(2))
                        .join(", ")}{" "}
                    </b>
                    to{" "}
                    <b>
                      {gcause.map((mp) => mp.retailerCharityName)?.[0]}
                      {". "}
                    </b>
                  </p>{" "}
                </div>
              )
            )}
        </div>
      )}
    </>
  );
};

export default memo(Goodcause);
